import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from "../service/http.service";
import { GlobalConfig } from "../../global";
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
	kazFed: any;
	worldFed: any;

	kazakhstanId: any;
	imgLang: string;

	constructor(public router: Router,
              private http: HttpService,
              public translate: TranslateService) {
	}

	ngOnInit(): void {
    this.imgLang = this.translate.getDefaultLang();
    this.translate.onLangChange.subscribe(lang => {
      this.imgLang = lang.lang
    })
	}

	openKazMap() {
		this.router.navigate(['/kazakhstan'])
		if (this.kazFed) {
			let countryObj = {
				type: 'country',
				id: this.kazakhstanId
			}
			sessionStorage.setItem('countryObj', JSON.stringify(countryObj));
			sessionStorage.setItem('kazFederation', JSON.stringify(this.kazFed));
			sessionStorage.removeItem('worldFederation');
		}
	}

	openWorldMap() {
		this.router.navigate(['/world-map'])
		if (this.worldFed) {

			sessionStorage.setItem('worldFederation', JSON.stringify(this.worldFed));
			sessionStorage.removeItem('kazFederation');
		}
	}

	redirectToAuth() {
		window.location.href = GlobalConfig.ADMIN_URL;
	}

}
